module.exports = __webpack_public_path__ + "media/livingroom.4052e0ea.mp3";